<template lang="pug">
  .multiple-changes-wrapper
    h2 Alterações múltiplas

    h3 selecione os {{$wp('employee')}} que receberão as mudanças

    RadioSlider(
      :items="categories.items",
      :current="categories.items.findIndex(i => i.id === categories.selected.id)",
      @selected="openItemsSelector"
    )

    .selectors
      PMultiSelect(
        ref="itemSelector"
        labelItem="name"
        v-model="$data[categories.selected.vmodel]"
        :title="categories.selected.name"
        :useState="categories.selected.useState"
        :useCommon="categories.selected.common"
        :disabled="!categories.selected"
      )

    .employee-fields
      h3 campos

      Validate(v-model="fieldsToUpdate.closingDate" :min="1" :max="28" :required="false")
        PTextField(label="dia de ínicio da folha" name="closingDate" type="number")

      PSelect(
        v-model="fieldsToUpdate.company"
        labelItem="name",
        title="local de trabalho",
        useCommon="companies/onlyActive"
      )

      PSelect(
        v-model="fieldsToUpdate.employer"
        labelItem="name",
        title="empregador",
        useCommon="employers"
      )

      PSelect(
        v-model="fieldsToUpdate.customRules"
        labelItem="name",
        title="regra de cálculo",
        useCommon="customRules"
      )

      PSelect(
        v-if="useWHB"
        labelItem="name",
        required
        title="regra de banco de horas",
        v-model="fieldsToUpdate.workHourBankRules",
        :loadDataFunction="fetchWhbRules"
      )

      PTextField(label="departamento" name="department" type="number" v-model="fieldsToUpdate.department")

      PTextField(label="função" name="funct" type="number" v-model="fieldsToUpdate.funct")

      PDatePicker(label="desligamento" required name="resignation" v-model="fieldsToUpdate.resignation")

    .beneficios
      h3 registro de benefícios

      .item
        Slider(:threeStates="true" v-model="fieldsToUpdate.hasVr")
        label possui vale refeição?

      .item
        Slider(:threeStates="true" v-model="fieldsToUpdate.hasVt")
        label possui vale transporte?

    .mobile
      h3 registro de pontos e apontamentos

      .item(v-for="f in ptsRegisterConfigs")
        Slider(:threeStates="true" v-model="$data.fieldsToUpdate[f.field]")
        label {{ f.text }}

    RoutineHandler.routine(v-model="fieldsToUpdate.routineInfo")

    .save
      .button
        PButton(color="success" size="lg" @click="save" :loading="saving" block) salvar

</template>

<script>
import Slider from 'src/common/inputs/Slider'
import RoutineHandler from '../details/RoutineHandler'

export default {
  name: 'MultipleChanges',
  components: {Slider, RoutineHandler},
  computed: {
    useWHB () {
      return this.$store.state.userInfo.compMan.hasWhbank
    }
  },
  data () {
    return {
      saving: false,
      categories: {
        selected: { name: this.$wp('companyShortName'), id: 'company', common: 'companies/onlyActive', vmodel: 'companies' },
        items: [
          { name: this.$wp('companyShortName'), id: 'company', common: 'companies/onlyActive', vmodel: 'companies' },
          { name: this.$wp('employee'), id: 'employee', common: 'employees/onlyNotFired', vmodel: 'employees' }
        ]
      },
      companies: {
        selected: []
      },
      employees: {
        selected: []
      },
      ptsRegisterConfigs: [
        {text: 'registrar horario de pausa automaticamente', field: 'autoPauseFill'},
        {text: 'registrar ponto em qualquer local de trabalho', field: 'phoneclockAll'},
        {text: 'gravar ponto com voz no aplicativo (android)', field: 'allowAppVoice'},
        {text: 'gravar ponto com foto no aplicativo (dispositivos móveis)', field: 'allowAppPhoto'},
        {text: 'mostrar jornada no aplicativo (dispositivos móveis)', field: 'allowAppShowDayJourney'},
        {text: 'mostrar feedback no aplicativo (android)', field: 'allowAppFeedback'},
        {
          text: 'permitir selecionar o local de trabalho que o ponto será registrado (android)',
          field: 'canSelectCompany',
          tooltip: 'Se o dispositivo estiver cadastrado para apenas um local de trabalho, esse local será automaticamente selecionado.'
        },
        {text: 'ativar reconhecimento facial (android)', field: 'recognizeFace'},
        {text: 'gravar ponto com voz no pontotel web (computador)', field: 'allowWebVoice'},
        {text: 'ativar dupla confirmação de registro de ponto (computador)', field: 'doubleCheckWeb'}
      ],
      fieldsToUpdate: {
        routineInfo: {
          phaseShift: null,
          initialDay: new Date(),
          routine: null
        },
        resignation: null,
        company: {selected: null},
        employer: {selected: null},
        customRules: {selected: null},
        workHourBankRules: {selected: null},
        closingDate: '',
        department: '',
        funct: '',
        hasVt: 1,
        hasVr: 1,
        allowAppVoice: 1,
        phoneclockAll: 1,
        autoPauseFill: 1,
        allowAppPhoto: 1,
        allowAppShowDayJourney: 1,
        allowAppFeedback: 1,
        canSelectCompany: 1,
        recognizeFace: 1,
        allowWebVoice: 1,
        doubleCheckWeb: 1,
        allowPunchSerial: 1
      }
    }
  },
  methods: {
    openItemsSelector (item) {
      this.categories.selected = item
      this.$refs.itemSelector.open()
    },
    async fetchWhbRules () {
      const items = await this.$API.whbRules.get()
      return [{id: null, name: 'Sem banco de horas'}, ...items.data.success]
    },
    async save () {
      const intToValue = x => x === 0 ? false : (x === 2 ? true : null)

      const params = {
        allowAppFeedback: intToValue(this.fieldsToUpdate.allowAppFeedback),
        allowAppPhoto: intToValue(this.fieldsToUpdate.allowAppPhoto),
        allowAppShowDayJourney: intToValue(this.fieldsToUpdate.allowAppShowDayJourney),
        allowAppVoice: intToValue(this.fieldsToUpdate.allowAppVoice),
        allowWebVoice: intToValue(this.fieldsToUpdate.allowWebVoice),
        phoneclockAll: intToValue(this.fieldsToUpdate.phoneclockAll),
        autoPauseFill: intToValue(this.fieldsToUpdate.autoPauseFill),
        recognizeFace: intToValue(this.fieldsToUpdate.recognizeFace),
        canSelectCompany: intToValue(this.fieldsToUpdate.canSelectCompany),
        doubleCheckWeb: intToValue(this.fieldsToUpdate.doubleCheckWeb),
        hasOnCall: null,
        hasVr: intToValue(this.fieldsToUpdate.hasVr),
        hasVt: intToValue(this.fieldsToUpdate.hasVt),
        resignation: {},
        closingDate: this.fieldsToUpdate.closingDate || undefined,
        funct: this.fieldsToUpdate.funct || undefined,
        department: this.fieldsToUpdate.department || undefined,
        workHourBankRules: this.fieldsToUpdate.workHourBankRules.selected || undefined,
        customRules: this.fieldsToUpdate.customRules.selected || undefined,
        company: this.fieldsToUpdate.company.selected ? [this.fieldsToUpdate.company.selected] : undefined,
        employer: this.fieldsToUpdate.employer.selected ? [this.fieldsToUpdate.employer.selected] : undefined
      }

      if (this.categories.selected.id === 'company') {
        params.companies = this.companies.selected.map(i => i.id)
      } else {
        params.employees = this.employees.selected.map(i => i.id)
      }

      if (this.fieldsToUpdate.routineInfo.routine) {
        params.routine = this.fieldsToUpdate.routineInfo.routine
        params.initialDay = this.fieldsToUpdate.routineInfo.initialDay
        params.routinePhaseShift = this.fieldsToUpdate.routineInfo.phaseShift
      }

      if (this.fieldsToUpdate.resignation) {
        params.resignation = {
          date: this.fieldsToUpdate.resignation.toISOString(),
          reason: 'Desligamento'
        }
      }

      this.saving = true
      try {
        await this.$API.applyAll.save(params)
        this.$modalDeSucesso('Alterações realizadas com sucesso')
      } catch (e) {
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível realizar as alterações')
      }
      this.saving = false
    }
  }
}
</script>

<style scoped lang="scss">
.multiple-changes-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 0.5fr;
  grid-column-gap: 30px;
  align-items: baseline;
  margin-bottom: 50px;

  h2 {
    grid-column: 1/5;
    text-align: center;
  }

  h3  {
    grid-column: 1/3;
  }

  .selectors {
    grid-column: 4/6;
  }

  .employee-fields {
    display: grid;
    grid-column-gap: 30px;
    grid-column: 1/3;
    grid-row: 3;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

    h3 {
      text-align: center;
      grid-column: 1/3;
    }
  }
  .mobile {
    grid-column: 3/6;
    grid-row: 3/5;
    h3 {
      text-align: center;
      grid-column: 1/3;
    }
  }
  .beneficios {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column: 1/3;
    grid-row: 4;
    h3 {
      text-align: center;
      grid-column: 1/3;
    }
  }
  .mobile, .beneficios {
    .item {
      display: grid;
      margin-bottom: 5px;
      grid-template-columns: 80px auto;
    }
  }
  .routine {
    display: grid;
    margin-top: 50px;
    margin-bottom: 20px;
    grid-template-columns: minmax(0, 0.45fr) minmax(0, 0.45fr) minmax(0, 0.33fr) minmax(0, 0.33fr) minmax(0, 0.33fr);
    grid-column-gap: 30px;
    grid-column: 1/6;
  }

  .save {
    width: 100%;
    display: grid;
    justify-items: center;
    grid-column: 5/6;
    grid-template-columns: 1fr 1fr 1fr;

    .button {
      width: 100%;
      grid-column: 2;
    }
  }
}
</style>
